'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (tableElement, columnOptions, index) {
	var renderer = columnOptions.renderer;
	if (!renderer) {
		renderer = createRenderer(tableElement, columnOptions, index);
		columnOptions.renderer = renderer;
	}
	return renderer;
};

exports.registerRenderer = registerRenderer;

var _StringColumn = require('./StringColumn');

var _StringColumn2 = _interopRequireDefault(_StringColumn);

var _NumericColumn = require('./NumericColumn');

var _NumericColumn2 = _interopRequireDefault(_NumericColumn);

var _BooleanColumn = require('./BooleanColumn');

var _BooleanColumn2 = _interopRequireDefault(_BooleanColumn);

var _DateColumn = require('./DateColumn');

var _DateColumn2 = _interopRequireDefault(_DateColumn);

var _EnumColumn = require('./EnumColumn');

var _EnumColumn2 = _interopRequireDefault(_EnumColumn);

var _LookupColumn = require('./LookupColumn');

var _LookupColumn2 = _interopRequireDefault(_LookupColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customColumnTypes = [];

function getRendererType(columnOptions) {
	switch (columnOptions.type) {
		case 'enum':
			return _EnumColumn2.default;
		case 'bool':
		case 'boolean':
			return _BooleanColumn2.default;
		case 'int':
		case 'float':
			return _NumericColumn2.default;
		case 'date':
			return _DateColumn2.default;
		case 'lookup':
			return _LookupColumn2.default;
		case 'string':
			return _StringColumn2.default;
		default:
			{
				// Custom column type resolution
				for (var i = 0; i < customColumnTypes.length; i++) {
					var c = customColumnTypes[i];
					if (c.selector(columnOptions)) {
						return c.type;
					}
				}
			}
	}
	// if no custom column exists, render value as StringColumn
	return _StringColumn2.default;
}

function createRenderer(tableElement, columnOptions, index) {
	var renderer = getRendererType(columnOptions);
	return new renderer(tableElement, columnOptions, index);
}

;

/**
 * Registers new custom column type.
 * @param selectorCallback {function} Function returning boolean value,
 * indicating whether the type can be used for given column. It gets column options as first parameter.
 * @param customColumnType Class derived from StringColumn or any sub-class.
 */
function registerRenderer(selectorCallback, customColumnType) {
	if (typeof selectorCallback === 'function' && typeof customColumnType === 'function') {
		customColumnTypes.push({ selector: selectorCallback, type: customColumnType });
	}
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/renderers/index.js
// module id = 758
// module chunks = 1